import * as React from "react";
import type { DialogButtonCallback, DialogOptions, DialogTypes } from "../../Actions/Dialogs/DialogActions";
import FontAwesomeLight from "../../Utilities/Platform/FontAwesome/FontAwesomeLight";
import Button from "../Buttons/Button";
import OkButton from "../Buttons/OkButton";

interface Props {
    header: string;
    content: React.ReactNode;
    type: DialogTypes;
    options: Array<DialogOptions> | false;
    onHide?: () => void;
}

export default class DialogContent extends React.Component<Props> {
    public buttonClick = (event: React.MouseEvent<HTMLButtonElement>, callback?: DialogButtonCallback): void => {
        event.stopPropagation();

        // Fire the callback
        if(callback) {
            Promise.resolve(callback(event))
                .then(hide => {
                    if(typeof hide === "undefined") {
                        hide = true;
                    }

                    if(hide && typeof this.props.onHide === "function") {
                        // Hide the dialog
                        this.props.onHide();
                    }
                })
                .catch(err => {
                    if(err.cancelled) {
                        return;
                    }

                    console.warn("Dialog swallowed error:", err);
                });
        } else if(typeof this.props.onHide === "function") {
            // Hide the dialog
            this.props.onHide();
        }
    };

    public render(): React.ReactNode {
        const { type, header, content, options } = this.props;

        let headerImage;

        if(type === "danger") {
            headerImage = <FontAwesomeLight icon="exclamation" />;
        } else if(type === "information") {
            headerImage = <FontAwesomeLight icon="info" />;
        } else if(type === "question") {
            headerImage = <FontAwesomeLight icon="question" />;
        } else if(type === "success") {
            headerImage = <FontAwesomeLight icon="check" />;
        } else if(type === "error") {
            headerImage = <FontAwesomeLight icon="times" />;
        } else if(type === "warning") {
            headerImage = <FontAwesomeLight icon="exclamation" />;
        } else if(type === "edit") {
            headerImage = <FontAwesomeLight icon="pencil" />;
        }

        return (
            <React.Fragment>
                <div className="dialog-header">
                    <div className="dialog-header-icon">
                        {headerImage}
                    </div>
                    <h3 className="dialog-header-title">
                        {header}
                    </h3>
                </div>
                <div className="dialog-body">
                    <div className="content">
                        {content}
                    </div>
                    {options && (
                        <div className="buttons">
                            {!!options.length && options.map((option, index) => (
                                <Button
                                    type="button"
                                    key={index}
                                    classes={option.classes}
                                    onClick={(e): void => {
                                        this.buttonClick(e, option.callback);
                                    }}
                                    data-testid={`dialog-button-${index}`}
                                    autoFocus={option.autoFocus}
                                >
                                    {option.label}
                                </Button>
                            ))}
                            {!options.length && (
                                <OkButton onClick={this.buttonClick} />
                            )}
                        </div>
                    )}
                </div>
            </React.Fragment>
        );
    }
}
